import { Time } from '@nicolaudie-group/ls-utilities'
import config from '@/config'

function formatDate(date, { tz = false, utc = false, short = false } = {}) {
  const parsed = Time.parseDate(date, 'raw')
  const longFormat = tz ? config.tzDateFormat : config.localDateFormat
  const formatOut = short ? config.shortDateFormat : longFormat
  return Time.dateTo(
    utc ? parsed : parsed.local(),
    'string',
    { formatOut },
  )
}

export default formatDate
